// Kitchen and Counter (docs/plans/stations.md): a device set to one shows only that view. The
// choice is this device's, per person and business, in localStorage like the alert sound.
import { useSyncExternalStore } from 'react'

export type StationMode = 'full' | 'kitchen' | 'counter'

const listeners = new Set<() => void>()
const key = (userId: string, tenantId: string) => `ims.station.${userId}.${tenantId}`

export function readStation(userId: string, tenantId: string): StationMode {
  try {
    const saved = localStorage.getItem(key(userId, tenantId))
    return saved === 'kitchen' || saved === 'counter' ? saved : 'full'
  } catch {
    return 'full'
  }
}

export function setStation(userId: string, tenantId: string, mode: StationMode) {
  try {
    if (mode === 'full') localStorage.removeItem(key(userId, tenantId))
    else localStorage.setItem(key(userId, tenantId), mode)
  } catch {
    // Storage blocked: the device stays as it was.
  }
  listeners.forEach((l) => l())
}

export function useStation(userId: string, tenantId: string | undefined): StationMode {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l)
      return () => listeners.delete(l)
    },
    () => (tenantId ? readStation(userId, tenantId) : 'full'),
  )
}

/** Where a device in this mode belongs. */
export const stationHome = (mode: 'kitchen' | 'counter') => `/station/${mode}`
